import store from '@/store';
import { SECTIONS_REQUEST } from '@/app/main/store/types';
import {
  FILING_TYPES, FINANCE_VERIFIED_STATUS, USER_ACCESS_TYPES, ROLES,
} from '@/constants';
import { USER_ROLES_REQUEST, LOGOUT } from '@/app/auth/store/types';
import { SET_ROUTE_TO_REDIRECT } from '@/app/admin/store/types';
import { USER_ID } from '../app/auth/store/constants';

const checkIfAppAccessPaid = (routeParams) => {
  const paymentRoute = 'payment';
  const queryParamForAccessPayment = { paymentType: 'access' };
  const targetRoute = routeParams.to.name;
  if (store.getters.getRoles.length > 0) {
    return false;
  }
  if (targetRoute !== paymentRoute && !store.getters.getIsAppAccessPaid) {
    routeParams.next({
      name: paymentRoute,
      query: queryParamForAccessPayment,
    });
    return true;
  }

  return false;
};

const checkIfAppClosed = (routeParams) => {
  const finalRoute = 'final';
  const targetRoute = routeParams.to.name;
  const { id } = routeParams.from.params;

  if (store.getters.getIsAppClosed && targetRoute !== finalRoute) {
    routeParams.next({
      params: {
        id: store.getters.getRoles.length > 0 ? id : null,
      },
      name: finalRoute,
    });
    return true;
  }

  if (store.getters.getIsAppClosed) {
    routeParams.next();
    return true;
  }

  return false;
};

const checkAccessToBusinessSection = (routeParams, sectionResponseData) => {
  const expensesSectionName = 'expenses';
  const targetRoute = routeParams.to.name;
  const isBusinessAccessType = store.getters.getAppAccessType === USER_ACCESS_TYPES.Business;
  const assetsSection = sectionResponseData.sections.find(section => section.sectionName === 'Assets');

  if (targetRoute === expensesSectionName && !isBusinessAccessType) {
    if (assetsSection.isCompleted) {
      routeParams.next();

      return true;
    }
  }
  return false;
};

const checkIfFileSectionIsCompleted = (routeParams, sectionResponseData) => {
  const targetRoute = routeParams.to.name;
  const menuItems = store.getters.getMenuItems;
  const isTargetSectionIsFileSection = routeParams.to.matched.some(item => item.path === '/:id?/main/file');
  const fileSection = menuItems.find(item => item.title === 'File');
  const { filingType } = sectionResponseData;
  const isEztxSolutionPaid = sectionResponseData.isEasyFilingPaid;
  const negotiationServicesRoute = 'negotiation';
  const proofsRoute = 'proofs';
  const decisionRoute = 'decision';
  const manualDownloadRoute = 'manual-download';
  const backPermission = store.getters.getBackPermission;
  const { id } = routeParams.from.params;

  if (isTargetSectionIsFileSection) {
    if (fileSection.completed) {
      if (filingType === FILING_TYPES.EZTX && isEztxSolutionPaid) {
        routeParams.next({
          params: {
            id: store.getters.getRoles.length > 0 ? id : null,
          },
          name: negotiationServicesRoute,
        });
        return true;
      }

      if (filingType === FILING_TYPES.MANUAL && targetRoute === decisionRoute && !backPermission) {
        routeParams.next({
          params: {
            id: store.getters.getRoles.length > 0 ? id : null,
          },
          name: manualDownloadRoute,
        });
        return true;
      }
    }

    if (filingType === FILING_TYPES.EZTX && isEztxSolutionPaid) {
      if (targetRoute !== decisionRoute) {
        routeParams.next();
        return true;
      }

      routeParams.next({
        params: {
          id: store.getters.getRoles.length > 0 ? id : null,
        },
        name: proofsRoute,
      });
      return true;
    }
  }

  return false;
};

const checkIfPreviousSectionCompleted = (routeParams) => {
  const previousRoute = routeParams.from.name;
  const menuItems = store.getters.getMenuItems;
  const targetSection = menuItems.findIndex(section => routeParams.to.path
    .indexOf(section.link) >= 0);
  const prevSection = menuItems[targetSection - 1];
  const finalSection = 'file';
  const firstNotCompletedTargetSection = menuItems.findIndex(item => item.completed === false);
  const { id } = routeParams.from.params;
  if (prevSection) {
    if (prevSection.completed) {
      routeParams.next({
        params: {
          id: store.getters.getRoles.length > 0 ? id : null,
        },
      });
      return true;
    }
  }
  if ((previousRoute === 'client' || previousRoute === null) && targetSection !== firstNotCompletedTargetSection) {
    routeParams.next({
      params: {
        id: store.getters.getRoles.length > 0 ? id : null,
      },
      name: menuItems[firstNotCompletedTargetSection]?.name || finalSection,
    });

    return true;
  }

  return false;
};

const checkIfNegotiatorServicesAvailable = (routeParams, sectionResponseData) => {
  const isTargetSectionIsFileSection = routeParams.to.matched.some(item => item.path === '/main/file');
  const areNegotiatorServicesAvailable = sectionResponseData
    .qualifyResolution !== FINANCE_VERIFIED_STATUS.ELECTRONIC_FILING_DISABLED;
  const { id } = routeParams.from.params;
  if (isTargetSectionIsFileSection && !areNegotiatorServicesAvailable) {
    routeParams.next({
      params: {
        id: store.getters.getRoles.length > 0 ? id : null,
      },
      name: 'qualify',
    });


    return true;
  }

  return false;
};


export const getSections = (to, from, next) => {
  const routeParams = { to, from, next };
  store.dispatch(SECTIONS_REQUEST, routeParams.to.params.id)
    .then(() => {
      routeParams.next();
    });
};

export const checkRouteForMainSections = (to, from, next) => {
  const routeParams = { to, from, next };
  if (!routeParams.to.params.id && store.getters.getRoles.length > 0) {
    next('/admin');
    return;
  }
  store.dispatch(SECTIONS_REQUEST, routeParams.to.params.id)
    .then((res) => {
      const responseData = res.data.currentUserApplication
        || store.getters.getCurrentApplicationData;
      if (checkIfAppAccessPaid(routeParams)) return;

      if (checkIfAppClosed(routeParams)) return;

      if (checkAccessToBusinessSection(routeParams, responseData)) return;

      if (checkIfFileSectionIsCompleted(routeParams, responseData)) return;

      if (checkIfNegotiatorServicesAvailable(routeParams, responseData)) return;

      if (checkIfPreviousSectionCompleted(routeParams)) return;

      next();
    })
    .catch(() => {
      if (store.getters.getApplicationAccessStatus === 'error') {
        next('/error');
        return;
      }
      next(false);
    });
};

export const checkRouteForFileSections = (to, from, next) => {
  const routeParams = { to, from, next };
  store.dispatch(SECTIONS_REQUEST, routeParams.to.params.id)
    .then((res) => {
      const responseData = res.data;

      if (checkIfAppAccessPaid(routeParams)) return;

      if (checkIfAppClosed(routeParams)) return;

      if (checkIfNegotiatorServicesAvailable(routeParams, responseData)) return;

      if (checkIfPreviousSectionCompleted(routeParams)) return;

      next();
    })
    .catch(() => {
      next(false);
    });
};

export const isAuthenticatedAndNotAdmin = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    store.dispatch(USER_ROLES_REQUEST)
      .then((response) => {
        const userRoles = response.data.roles;
        const isNotCoach = !userRoles.includes(ROLES.COACH);
        const isNotNegotiator = !userRoles.includes(ROLES.NEGOTIATOR);
        const isRegularUser = !userRoles.length;
        const isCertifiedPublicAccountant = userRoles.includes(ROLES.CPA);
        if (isNotNegotiator || isNotCoach || isRegularUser) {
          if (isCertifiedPublicAccountant && to.path.includes('buy-coaching')) {
            next(false);
            return;
          }
          if (store.getters.getRouteToRedirect !== '') {
            next(store.getters.getRouteToRedirect);
            store.commit(SET_ROUTE_TO_REDIRECT, '');
            return;
          }
          next();
          return;
        }
        next('/admin');
      });
  } else {
    const route = to.path;
    if (to.params.id != null) {
      localStorage.setItem(USER_ID, to.params.id);
    }
    store.commit(SET_ROUTE_TO_REDIRECT, route);
    next('/');
  }
};

export const isNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }

  if (to.path === '/logout') {
    next();
    return;
  }

  if (store.getters.getApplicationAccessStatus === 'error') {
    next();
    return;
  }
  next('/main/personal');
};

export const isAuthenticatedAndHasAdminRights = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    store.dispatch(USER_ROLES_REQUEST)
      .then((response) => {
        const userRoles = response.data.roles;
        if (userRoles.length) {
          if (store.getters.getRouteToRedirect !== '') {
            next(store.getters.getRouteToRedirect);
            store.commit(SET_ROUTE_TO_REDIRECT, '');
            return;
          }
          next();
          return;
        }
        next('/');
      });
  } else {
    const route = to.path;
    store.commit(SET_ROUTE_TO_REDIRECT, route);
    next('/');
  }
};

export const isSuperAdmin = (to, from, next) => {
  store.dispatch(USER_ROLES_REQUEST)
    .then((response) => {
      const userRoles = response.data.roles;
      if (userRoles.find(role => role === ROLES.SUPER_ADMIN)) {
        next();
        return;
      }
      next('/admin');
    });
};

export const logoutUser = (to, from, next) => {
  store.dispatch(LOGOUT).then(() => {
    next('/login');
  });
};
